export default [
    {
      path: '/dash',
      name: 'template',
      component: () => import(/* webpackChunkName: "dash" */ '../views/Template/Template.vue'),
      meta: { requiresAuth: true},
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: () => import(/* webpackChunkName: "home" */ '../components/dashboard/pages/DashboardPage.vue')
        },
        {
          path: 'admin/dashboard',
          name: 'admin-dashboard',
          component: () => import(/* webpackChunkName: "home" */ '../components/admin/dashboard/pages/DashboardPage.vue')
        },
        {
          path: 'empresas',
          name: 'empresas',
          component: () => import(/* webpackChunkName: "empresas" */ '../components/admin/empresas/pages/Companies.vue'),
          children: [
            {
              path: 'listado',
              name: 'companiesList',
              component: () => import(/* webpackChunkName: "companiesList" */ '../components/admin/empresas/pages/CompaniesList.vue')
            },
            {
              path: 'registrar',
              name: 'companyRegister',
              component: () => import(/* webpackChunkName: "companyRegister" */ '../components/admin/empresas/pages/CompanyRegister.vue')
            },
            {
              path: 'actualizar/:id',
              name: 'updateCompanyForm',
              component: () => import(/* webpackChunkName: "companyRegister" */ '../components/admin/empresas/pages/UpdateCompany.vue')
            },
          ]
        },
        {
          path: 'recomended-items-list',
          name: 'recomendedItems',
          component: () => import(/* webpackChunkName: "empresas" */ '../components/admin/empresas/pages/Companies.vue'),
          children: [
            {
              path: 'listado',
              name: 'recomendedItemsList',
              component: () => import(/* webpackChunkName: "recomendedItemList" */ '../components/admin/webItems/pages/WebItemsList.vue')
            }
          ]
        },
        {
          path: 'configuration-banners',
          name: 'configurationBanners',
          component: () => import(/* webpackChunkName: "configuration" */ '../components/admin/banners/pages/ImageList.vue')
        },
        {
          path: 'admin/usuarios',
          name: 'adminUsers',
          component: () => import(/* webpackChunkName: "user" */ '../components/admin/users/pages/Users.vue'),
          children: [
            {
              path: 'listado',
              name: 'usersListAdmin',
              component: () => import(/* webpackChunkName: "userList" */ '../components/admin/users/pages/UserList.vue')
            },
            {
              path: 'actualizar/:id',
              name: 'updateUserAdmin',
              component: () => import(/* webpackChunkName: "registerUser" */ '../components/admin/users/pages/UpdateUser.vue')
            },
          ]
        },
        {
          path: 'admin/invitaciones',
          name: 'adminInvitations',
          component: () => import(/* webpackChunkName: "invitations" */ '../components/admin/chatbotInvitations/pages/Invitations.vue'),
          children: [
            {
              path: 'listado',
              name: 'chatbot-invitations.index',
              component: () => import(/* webpackChunkName: "invitationList" */ '../components/admin/chatbotInvitations/pages/InvitationList.vue')
            },
            {
              path: 'registrar',
              name: 'chatbot-invitations.register',
              component: () => import(/* webpackChunkName: "registerInvitation" */ '../components/admin/chatbotInvitations/pages/ChatbotInvitationRegister.vue')
            },
            {
              path: 'actualizar',
              name: 'chatbot-invitations.update',
              component: () => import(/* webpackChunkName: "updateInvitation" */ '../components/admin/chatbotInvitations/pages/ChatbotInvitationUpdate.vue')
            },
          ]
        },
        {
          path: 'admin/chatbot/usuarios',
          name: 'adminChatbotUsers',
          component: () => import(/* webpackChunkName: "chatbotUsers" */ '../components/admin/chatbotUsers/pages/Users.vue'),
          children: [
            {
              path: 'listado',
              name: 'chatbot-users.index',
              component: () => import(/* webpackChunkName: "UserList" */ '../components/admin/chatbotUsers/pages/UserList.vue')
            }
          ]
        },
        {
          path: 'usuarios',
          name: 'usuarios',
          component: () => import(/* webpackChunkName: "user" */ '../components/users/pages/Usuarios.vue'),
          children: [
            {
              path: 'listado',
              name: 'listadoUsuarios',
              component: () => import(/* webpackChunkName: "userList" */ '../components/users/pages/UserList.vue')
            },
            {
              path: 'registrar',
              name: 'registrarUsuario',
              component: () => import(/* webpackChunkName: "registerUser" */ '../components/users/pages/RegisterUser.vue')
            },
            {
              path: 'actualizar/:id',
              name: 'updateUser',
              component: () => import(/* webpackChunkName: "registerUser" */ '../components/users/pages/UpdateUser.vue')
            },
          ]
        },
        {
          path: 'comisiones-vendedores',
          name: 'SalesCommissionTracker',
          component: () => import(/* webpackChunkName: "user" */ '../components/SalesCommissionTracker/pages/SalesCommissionTracker.vue'),
          children: [
            {
              path: 'listado',
              name: 'SalesCommissionTrackerList',
              component: () => import(/* webpackChunkName: "userList" */ '../components/SalesCommissionTracker/pages/SalesCommissionTrackerDashboard.vue')
            }
          ]
        },
        {
          path: 'perfil',
          name: 'perfil',
          component: () => import(/* webpackChunkName: "perfil" */ '../components/perfil/pages/Perfil.vue')
        },
        {
          path: 'canasta',
          name: 'canasta',
          component: () => import(/* webpackChunkName: "canasta" */ '../components/canasta/Canasta.vue'),
          children: [
            {
              path: 'procesar-canasta',
              name: 'processCartVendedor',
              component: () => import(/* webpackChunkName: "listadoCanasta" */ '../components/canasta/vendedor/pages/Cart.vue')
            },
            {
              path: 'procesar-carrito',
              name: 'processCartClienteWeb',
              component: () => import(/* webpackChunkName: "listadoCanasta" */ '../components/canasta/clienteWeb/pages/Cart.vue')
            },
          ]
        },
        {
          path: 'catalogo/:categoryCode/:slug',
          name: 'listadoInventario',
          component: () => import(/* webpackChunkName: "listadoInventario" */ '../components/InventoryProveedor/pages/InventoryList.vue')
        },
        {
          path: 'pedidos',
          name: 'pedidos',
          component: () => import(/* webpackChunkName: "pedidos" */ '../components/pedidos/pages/Pedidos.vue'),
          children: [
            {
              path: 'listado',
              name: 'ListadoPedidos',
              component: () => import(/* webpackChunkName: "listadoPedidos" */ '../components/pedidos/pages/ListarPedidos.vue')
            },
            {
              path: 'pedido/:id',
              name: 'InfoPedido',
              component: () => import(/* webpackChunkName: "infoPedidos" */ '../components/pedidos/pages/InfoPedido.vue')
            },
          ]
        },
        {
          path: 'pedidos/api',
          name: 'orderApi',
          component: () => import(/* webpackChunkName: "pedidos" */ '../components/Order/api/pages/Pedidos.vue'),
          children: [
            {
              path: 'listado',
              name: 'ordersListApi',
              component: () => import(/* webpackChunkName: "listadoPedidos" */ '../components/Order/api/pages/ListarPedidos.vue')
            },
            {
              path: 'pedido/:id',
              name: 'infoDetailOrderApi',
              component: () => import(/* webpackChunkName: "infoPedidos" */ '../components/Order/api/pages/InfoPedido.vue')
            },
          ]
        },
        {
          path: 'pedidos-cliente-web',
          name: 'pedidos-cliente-web',
          component: () => import(/* webpackChunkName: "pedidos" */ '../components/pedidosClienteWeb/pages/Pedidos.vue'),
          children: [
            {
              path: 'listado',
              name: 'ListadoPedidosClienteWeb',
              component: () => import(/* webpackChunkName: "listadoPedidos" */ '../components/pedidosClienteWeb/pages/ListarPedidos.vue')
            },
            {
              path: 'pedido/:id',
              name: 'InfoPedidoClienteWeb',
              component: () => import(/* webpackChunkName: "infoPedidos" */ '../components/pedidosClienteWeb/pages/InfoPedido')
            },
          ]
        },
        {
          path: 'proveedor',
          name: 'pedidosProveedor',
          component: () => import(/* webpackChunkName: "pedidosProveedor" */ '../components/pedidosProveedor/pages/Pedidos.vue'),
          children: [
            {
              path: 'listado',
              name: 'getPedidosProveedor',
              component: () => import(/* webpackChunkName: "pedidosProveedorListado" */ '../components/pedidosProveedor/pages/GetPedidos.vue')
            },
            {
              path: ':id',
              name: 'InfoPedidoProveedor',
              component: () => import(/* webpackChunkName: "pedidosProveedorInfo" */ '../components/pedidosProveedor/pages/InfoPedido.vue')
            },
          ]
        },
        {
          path: 'busqueda/:texto/:time',
          name: 'SearchItems',
          component: () => import('../components/searchItems/Pages/SearchItem.vue')
        },
        {
          path: 'busqueda/detail/:referencia',
          name: 'ItemDetail',
          component: () => import('../components/searchItems/Pages/Iteminfo.vue')
        },
        {
          path: 'empresa/configuracion',
          name: 'configuracion',
          component: () => import(/* webpackChunkName: "configuration" */ '../components/configuration/pages/Configuracion.vue')
        },
        {
          path: 'empresa/configuracion-cliente-web',
          name: 'configuracionClienteWeb',
          component: () => import(/* webpackChunkName: "configuration" */ '../components/configurationClienteWeb/pages/Configuracion.vue')
        },
        {
          path: 'empresa/configuracion-odoo-cliente',
          name: 'configuracionClienteOdoo',
          component: () => import(/* webpackChunkName: "configuration" */ '../components/OdooClientInstance/pages/OdooClientInstance.vue')
        },
        {
          path: 'empresa/inventario',
          name: 'inventoryEmpresa',
          component: () => import(/* webpackChunkName: "inventarioEmpresa" */ '../components/empresa/items/pages/Inventory.vue'),
          children: [
            {
              path: 'listado',
              name: 'GetItemsListEmpresa',
              component: () => import(/* webpackChunkName: "listadoInventarioEmpresa" */ '../components/empresa/items/pages/GetItemsList.vue')
            },
            {
              path: 'listado-archivados',
              name: 'GetItemsArchivedListEmpresa',
              component: () => import(/* webpackChunkName: "listadoInventarioEmpresa" */ '../components/empresa/items/pages/ItemArchivedList.vue')
            },
            {
              path: 'registrar',
              name: 'registerItemEmpresa',
              component: () => import(/* webpackChunkName: "registrarItemEmpresa" */ '../components/empresa/items/pages/CreateItem.vue')
            },
            {
              path: 'editar/:id',
              name: 'editItemEmpresa',
              //component: () => import(/* webpackChunkName: "editarItemEmpresa" */ '../components/empresa/inventory/RegisterItem.vue')
              component: () => import(/* webpackChunkName: "editarItemEmpresa" */ '../components/empresa/items/pages/UpdateItem.vue')
              
            },
          ]
        },
        {
          path: 'empresa/categorias',
          name: 'categoriesEmpresa',
          component: () => import(/* webpackChunkName: "categoriesEmpresa" */ '../components/empresa/categories/pages/Categories.vue'),
          children: [
            {
              path: 'listado',
              name: 'GetCategoriesListEmpresa',
              component: () => import(/* webpackChunkName: "categoriesList" */ '../components/empresa/categories/pages/GetCategoriesList.vue')
            },
            {
              path: 'registrar',
              name: 'registerCategoryEmpresa',
              component: () => import(/* webpackChunkName: "registerCategory" */ '../components/empresa/categories/pages/CreateCategory.vue')
            },
            {
              path: 'editar/:id',
              name: 'editCategoryEmpresa',
              component: () => import(/* webpackChunkName: "editCategory" */ '../components/empresa/categories/pages/UpdateCategory.vue')
            },
          ]
        },
        {
          path: 'empresa/atributos',
          name: 'attributesEmpresa',
          component: () => import(/* webpackChunkName: "attributesEmpresa" */ '../components/empresa/attributes/pages/Attributes.vue'),
          children: [
            {
              path: 'listado',
              name: 'GetAttributesListEmpresa',
              component: () => import(/* webpackChunkName: "attributesEmpresaList" */ '../components/empresa/attributes/pages/GetAttributesList.vue')
            },
            {
              path: 'registrar',
              name: 'registerAttributeEmpresa',
              component: () => import(/* webpackChunkName: "registerAttribute" */ '../components/empresa/attributes/pages/CreateAttributes.vue')
            },
            {
              path: 'editar/:id',
              name: 'editAttributeEmpresa',
              component: () => import(/* webpackChunkName: "editAttribute" */ '../components/empresa/attributes/pages/UpdateAttributes.vue')
            },
          ]
        },
        {
          path: 'empresa/listad-de-precios',
          name: 'priceListEmpresa',
          component: () => import(/* webpackChunkName: "priceListempresa" */ '../components/empresa/priceList/pages/PriceList.vue'),
          children: [
            {
              path: 'listado',
              name: 'getPriceListEmpresa',
              component: () => import(/* webpackChunkName: "getriceListEmpresa" */ '../components/empresa/priceList/pages/GetPriceList.vue')
            },
            {
              path: 'registrar',
              name: 'registerPriceListEmpresa',
              component: () => import(/* webpackChunkName: "registerPriceList" */ '../components/empresa/priceList/pages/CreatePriceList.vue')
            },
            {
              path: 'editar/:id',
              name: 'editPriceListEmpresa',
              component: () => import(/* webpackChunkName: "editPriceList" */ '../components/empresa/priceList/pages/UpdatePriceList.vue')
            },
          ]
        },
        {
          path: 'catalogo/:id/:category',
          name: 'inventoryEmpresaList',
          component: () => import(/* webpackChunkName: "inventoryListEmpresa" */ '../components/InventoryEmpresa/pages/InventoryEmpresaList.vue')
        },
        {
          path: 'busqueda/:codigo',
          name: 'itemEmpresaDetail',
          component: () => import(/* webpackChunkName: "itemEmpresaDetail" */ '../components/InventoryEmpresa/pages/ItemEmpresaDetail.vue')
        },
        {
          path: 'precios-personalizados',
          name: 'preciosPersonalizados',
          component: () => import(/* webpackChunkName: "itemEmpresaDetail" */ '../components/precioPersonalizado/pages/Precios.vue'),
          children: [
            {
              path: 'listado',
              name: 'preciosPersonalizadosList',
              component: () => import(/* webpackChunkName: "getriceListEmpresa" */ '../components/precioPersonalizado/pages/ItemsList.vue')
            },
          ]
        },
        {
          path: 'ventas',
          name: 'ventas',
          component: () => import(/* webpackChunkName: "ventas" */ '../components/ventas/Ventas.vue'),
          children: [
            {
              path: 'listado',
              name: 'ListadoVentas',
              component: () => import(/* webpackChunkName: "ListadoVentas" */ '../components/ventas/ListarVentas.vue')
            },
            {
              path: 'venta/:id',
              name: 'InfoVenta',
              component: () => import(/* webpackChunkName: "InfoVenta" */ '../components/ventas/InfoVenta.vue')
            },
            {
              path: 'realizar-venta',
              name: 'RealizarVenta',
              component: () => import(/* webpackChunkName: "Venta" */ '../components/ventas/RealizarVenta.vue')
            },
            {
              path: 'Ventas-totales',
              name: 'ListadoVentasTotales',
              component: () => import(/* webpackChunkName: "ListadoVentasTotales" */ '../components/ventas/VentasTotales.vue')
            },
          ]
        },
        {
          path: 'clientes',
          name: 'clientes',
          component: () => import(/* webpackChunkName: "clientes" */ '../components/clientes/pages/Clientes.vue'),
          children: [
            {
              path: 'listado',
              name: 'ListadoClientes',
              component: () => import(/* webpackChunkName: "listadoClientes" */ '../components/clientes/pages/ClientesList.vue')
            },
            {
              path: 'registrar',
              name: 'registerCliente',
              component: () => import(/* webpackChunkName: "listadoClientes" */ '../components/clientes/pages/RegisterCliente.vue')
            },{
              path: 'actualizar/:id',
              name: 'updateCliente',
              component: () => import(/* webpackChunkName: "registerUser" */ '../components/clientes/pages/UpdateCliente.vue')
            },{
              path: 'info/:id',
              name: 'clientDetail',
              component: () => import(/* webpackChunkName: "registerUser" */ '../components/clientes/pages/ClientDetail.vue')
            },
          ]
        },
      ]
    },
    {
      path: '/pedido/:id',
      name: 'printVenta',
      component: () => import(/* webpackChunkName: "printVenta" */ '../components/ventas/PrintVenta.vue')
    },
    {
      path: '/',
      name: 'login',
      meta: {title: 'Buckets' },
  
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../components/login/Login.vue')
    },
  ]